import React, { useState, useEffect } from 'react'
import Layout from 'components/LayoutForPortal'
import IntlMessages from "util/IntlMessages"
import Title from 'components/Title'
import Widget from 'components/Widget'
import { Form, Radio, Checkbox,Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux'
import { DataGetAction } from 'redux/actions/http'
import { DataRequestAction } from '../../../redux/actions/http'
const Index = () => {

    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const carePlanProps = useSelector(state => state.carePlanR)

    const { patientBaseLineQuestion,baseLineLoader } = carePlanProps

    const fetchPatientBaseLine = () => {
        dispatch(DataGetAction('fetchBaseLineQuestion', '', 'fetchingBaseLineQuestion'))
    }
    useEffect(fetchPatientBaseLine, [])


    const onFinish = values => {
        patientBaseLineQuestion.map((Item, index) => {
            Item.selected = [values[`QuestionNo_${index}`]];
            return Item
        })
        dispatch(DataRequestAction('PUT', 'updatePatientBaseLine', patientBaseLineQuestion, '', 'updatingBaseLine', false))
    };
    const [value, setValue] = useState(1);
    const [state, setstate] = useState(true)
    console.log(setstate)
    console.log(value)
    const onChange = e => {
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
    };

    const layout = {
        labelCol: { span: 3 },
        wrapperCol: { span: 21 },
    };

    const renderRadioOption = (Item) => {
        const data = Item.questionOptionImage ? Item.questionOptionImage : Item.questionOption
        return data.map((item, index) => {
            return <Radio value={index} disabled={state}>{item.optionLabel}</Radio>
        })
    }

    const renderCheckBoxOption = (Item) => {
        const data = Item.questionOptionImage ? Item.questionOptionImage : Item.questionOption
        return data.map((item, index) => {
            return <Checkbox value={index} disabled={state}> {item.optionLabel}</Checkbox>
        })
    }

    const renderBaseLineQuestion = () => {
        if (patientBaseLineQuestion && patientBaseLineQuestion.length) {
            return patientBaseLineQuestion.map((Item, index) => {
                if (Item.questionType !== "TextArea") {
                    let selectedOption = parseInt(Item.selected[0]);
                    if (Item.questionType === "Radio") {
                        return <Form.Item
                            name={`QuestionNo_${index}`}
                            label={Item.questionLabel}
                            rules={[
                                {
                                    required: true,
                                    message: 'this is required',
                                },
                            ]}
                            initialValue={selectedOption}
                        >
                            <Radio.Group onChange={onChange} value={selectedOption}>
                                {renderRadioOption(Item)}
                            </Radio.Group>
                        </Form.Item>
                    }
                    else if (Item.questionType === "CheckBox") {
                        return <Form.Item
                            name={`QuestionNo_${index}`}
                            label={Item.questionLabel}
                            rules={[
                                {
                                    required: true,
                                    message: 'this is required',
                                },
                            ]}
                        >
                            <Checkbox.Group value={selectedOption}>
                                {renderCheckBoxOption(Item)}
                            </Checkbox.Group>
                        </Form.Item>
                    }
                }
                return Item
            })
        }
    }

    return (
        <Layout>
         {baseLineLoader ? <Spin size="large"/> :   <Form
                {...layout}
                layout="horizontal"
                name="resetPasswprd"
                onFinish={onFinish}
                form={form}
            >
                <div className="gx-d-flex gx-flex-row gx-justify-content-between gx-mb-2">
                    <Title title={<IntlMessages id="patientBaseline.pageTitle" />} />
                    {/* {state && <Button type="primary" className="gx-pt-0 gx-mb-0" onClick={() => setstate(false)}>Edit</Button>}
                    {!state && <Button type="primary" className="gx-pt-0 gx-mb-0" htmlType="submit" >Update</Button>} */}
                </div>

                <Widget styleName='header-with-bg' title={<h6 className="gx-text-capitalize">Activity</h6>}>
                    {renderBaseLineQuestion()}
                </Widget>
            </Form>}

        </Layout>
    )
}

export default Index
